export const CATEGORIES = [
  'SaaS',
  'AI',
  'Developer Tools',
  'Education',
  'Marketplace',
  'Consumer',
  'Fintech',
  'Health',
  'Productivity',
  'Other',
] as const

export const STATUSES = ['Active', 'Building', 'Paused', 'Deprecated', 'Discontinued', 'Acquired'] as const

export const SOCIAL_FIELDS: { key: string; label: string; placeholder: string }[] = [
  { key: 'twitter', label: 'X / Twitter', placeholder: 'handle' },
  { key: 'github', label: 'GitHub', placeholder: 'username' },
  { key: 'tiktok', label: 'TikTok', placeholder: 'https://tiktok.com/@you' },
  { key: 'instagram', label: 'Instagram', placeholder: 'https://instagram.com/you' },
  { key: 'youtube', label: 'YouTube', placeholder: 'https://youtube.com/@you' },
  { key: 'linkedin', label: 'LinkedIn', placeholder: 'https://linkedin.com/in/you' },
  { key: 'email', label: 'Email', placeholder: 'you@example.com' },
]
